import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

/* Layout */
import Layout from "../views/layout/Layout";

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
export const constantRouterMap = [
  {
    path: "/login",
    component: () => import("@/views/login/index"),
    hidden: true
  },
  { path: "/404", component: () => import("@/views/404"), hidden: true },
  {
    path: "",
    component: Layout,
    redirect: "/home",
    meta: { title: "首页", icon: "home" },
    children: [
      {
        path: "home",
        name: "home",
        component: () => import("@/views/home/index"),
        meta: { title: "仪表盘", icon: "dashboard" }
      }
    ]
  }
];

export const asyncRouterMap = [
  {
    path: "/pms",
    component: Layout,
    redirect: "/pms/product",
    name: "pms",
    meta: { title: "商品", icon: "product" },
    children: [
      {
        path: "product",
        name: "product",
        component: () => import("@/views/pms/product/index"),
        meta: { title: "商品列表", icon: "product-list", keepAlive: true }
      },
      {
        path: "addProduct",
        name: "addProduct",
        component: () => import("@/views/pms/product/add"),
        meta: { title: "添加商品", icon: "product-add" }
      },
      {
        path: "updateProduct",
        name: "updateProduct",
        component: () => import("@/views/pms/product/update"),
        meta: { title: "修改商品", icon: "product-add" },
        hidden: true
      },
      {
        path: "productCate",
        name: "productCate",
        component: () => import("@/views/pms/productCate/index"),
        meta: { title: "商品分类", icon: "product-cate", keepAlive: true }
      },
      {
        path: "addProductCate",
        name: "addProductCate",
        component: () => import("@/views/pms/productCate/add"),
        meta: { title: "添加商品分类" },
        hidden: true
      },
      {
        path: "updateProductCate",
        name: "updateProductCate",
        component: () => import("@/views/pms/productCate/update"),
        meta: { title: "修改商品分类" },
        hidden: true
      },
      {
        path: "productAttr",
        name: "productAttr",
        component: () => import("@/views/pms/productAttr/index"),
        meta: { title: "商品类型", icon: "product-attr", keepAlive: true }
      },
      {
        path: "productAttrList",
        name: "productAttrList",
        component: () => import("@/views/pms/productAttr/productAttrList"),
        meta: { title: "商品属性列表" },
        hidden: true
      },
      {
        path: "addProductAttr",
        name: "addProductAttr",
        component: () => import("@/views/pms/productAttr/addProductAttr"),
        meta: { title: "添加商品属性" },
        hidden: true
      },
      {
        path: "updateProductAttr",
        name: "updateProductAttr",
        component: () => import("@/views/pms/productAttr/updateProductAttr"),
        meta: { title: "修改商品属性" },
        hidden: true
      },
      {
        path: "brand",
        name: "brand",
        component: () => import("@/views/pms/brand/index"),
        meta: { title: "品牌管理", icon: "product-brand", keepAlive: true }
      },
      {
        path: "addBrand",
        name: "addBrand",
        component: () => import("@/views/pms/brand/add"),
        meta: { title: "添加品牌" },
        hidden: true
      },
      {
        path: "updateBrand",
        name: "updateBrand",
        component: () => import("@/views/pms/brand/update"),
        meta: { title: "编辑品牌" },
        hidden: true
      },
      // 客服管理
      {
        path: "customer",
        name: "customer",
        component: () => import("@/views/pms/customer/index"),
        meta: { title: "客服回复管理", keepAlive: true }
      },
      // 评价管理
      {
        path: "comment",
        name: "comment",
        component: () => import("@/views/pms/comment/index"),
        meta: { title: "评价管理", keepAlive: true }
      }
    ]
  },
  {
    path: "/bms",
    component: Layout,
    redirect: "/bms/blindBox",
    name: "bms",
    meta: { title: "盲盒", icon: "product" },
    children: [
      {
        path: "blindBox",
        name: "blindBox",
        component: () => import("@/views/bms/blindBox/index"),
        meta: { title: "盲盒列表", icon: "product-list", keepAlive: true }
      },
      {
        path: "addBlindBox",
        name: "addBlindBox",
        component: () => import("@/views/bms/blindBox/add"),
        meta: { title: "添加盲盒", icon: "product-add" }
      },
      {
        path: "updateBlindBox",
        name: "updateBlindBox",
        component: () => import("@/views/bms/blindBox/update"),
        meta: { title: "修改盲盒", icon: "product-add" },
        hidden: true
      },
      {
        path: "blindBoxAttribute",
        name: "blindBoxAttribute",
        component: () => import("@/views/bms/attribute/index"),
        meta: { title: "盲盒属性", icon: "product-add" },
        hidden: false
      }
    ]
  },
  {
    path: "/cms",
    component: Layout,
    redirect: "/cms/productSubject",
    name: "cms",
    meta: { title: "专题", icon: "product" },
    children: [
      {
        path: "productSubject",
        name: "productSubject",
        component: () => import("@/views/cms/productSubject"),
        meta: { title: "商品专题", keepAlive: true },
        hidden: true
      },
      {
        path: "subjectCategory",
        name: "subjectCategory",
        component: () => import("@/views/cms/subjectCategory"),
        meta: { title: "专题分类", keepAlive: true },
        hidden: true
      }
    ]
  },
  {
    path: "/mms",
    component: Layout,
    redirect: "/mms/merchant",
    name: "mms",
    meta: { title: "商户", icon: "product" },
    children: [
      {
        path: "merchant",
        name: "merchant",
        component: () => import("@/views/mms/merchant"),
        meta: { title: "商户列表", keepAlive: true },
        hidden: true
      },
      {
        path: "addMerchant",
        name: "addMerchant",
        component: () => import("@/views/mms/add"),
        meta: { title: "添加商户" },
        hidden: true
      },
      {
        path: "updateMerchant",
        name: "updateMerchant",
        component: () => import("@/views/mms/update"),
        meta: { title: "修改商户" },
        hidden: true
      }
    ]
  },
  {
    path: "/lms",
    component: Layout,
    redirect: "/lms/lottery",
    name: "lms",
    meta: { title: "抽奖" },
    children: [
      {
        path: "lottery",
        name: "lottery",
        component: () => import("@/views/lms/lottery"),
        meta: { title: "活动列表", keepAlive: true },
        hidden: true
      }
    ]
  },
  {
    path: "/dms",
    component: Layout,
    redirect: "/dms/card",
    name: "dms",
    meta: { title: "卡券", icon: "sms-coupon" },
    children: [
      {
        path: "card",
        name: "card",
        component: () => import("@/views/dms/card"),
        meta: { title: "卡券列表", keepAlive: true },
        hidden: true
      }
    ]
  },
  {
    path: "/oms",
    component: Layout,
    redirect: "/oms/order",
    name: "oms",
    meta: { title: "订单", icon: "order" },
    children: [
      {
        path: "order",
        name: "order",
        component: () => import("@/views/oms/order/index"),
        meta: { title: "订单列表", icon: "product-list" , keepAlive: true}
      },
      {
        path: "orderDetail",
        name: "orderDetail",
        component: () => import("@/views/oms/order/orderDetail"),
        meta: { title: "订单详情" },
        hidden: true
      },
      {
        path: "deliverOrderList",
        name: "deliverOrderList",
        component: () => import("@/views/oms/order/deliverOrderList"),
        meta: { title: "发货列表" },
        hidden: true
      },
      {
        path: "orderSetting",
        name: "orderSetting",
        component: () => import("@/views/oms/order/setting"),
        meta: { title: "订单设置", icon: "order-setting" }
      },
      {
        path: "returnApply",
        name: "returnApply",
        component: () => import("@/views/oms/apply/index"),
        meta: { title: "退货申请处理", icon: "order-return" }
      },
      {
        path: "returnReason",
        name: "returnReason",
        component: () => import("@/views/oms/apply/reason"),
        meta: { title: "退货原因设置", icon: "order-return-reason" }
      },
      {
        path: "returnApplyDetail",
        name: "returnApplyDetail",
        component: () => import("@/views/oms/apply/applyDetail"),
        meta: { title: "退货原因详情" },
        hidden: true
      }
    ]
  },
  {
    path: "/sms",
    component: Layout,
    redirect: "/sms/coupon",
    name: "sms",
    meta: { title: "营销", icon: "sms" },
    children: [
      {
        path: "flash",
        name: "flash",
        component: () => import("@/views/sms/flash/index"),
        meta: { title: "秒杀活动列表", icon: "sms-flash", keepAlive: true }
      },
      {
        path: "flashSession",
        name: "flashSession",
        component: () => import("@/views/sms/flash/sessionList"),
        meta: { title: "秒杀时间段列表" },
        hidden: true
      },
      {
        path: "selectSession",
        name: "selectSession",
        component: () => import("@/views/sms/flash/selectSessionList"),
        meta: { title: "秒杀时间段选择" },
        hidden: true
      },
      {
        path: "flashProductRelation",
        name: "flashProductRelation",
        component: () => import("@/views/sms/flash/productRelationList"),
        meta: { title: "秒杀商品列表" },
        hidden: true
      },
      {
        path: "coupon",
        name: "coupon",
        component: () => import("@/views/sms/coupon/index"),
        meta: { title: "优惠券列表", icon: "sms-coupon", keepAlive: true }
      },
      {
        path: "addCoupon",
        name: "addCoupon",
        component: () => import("@/views/sms/coupon/add"),
        meta: { title: "添加优惠券" },
        hidden: true
      },
      {
        path: "updateCoupon",
        name: "updateCoupon",
        component: () => import("@/views/sms/coupon/update"),
        meta: { title: "修改优惠券" },
        hidden: true
      },
      {
        path: "couponHistory",
        name: "couponHistory",
        component: () => import("@/views/sms/coupon/history"),
        meta: { title: "优惠券领取详情" },
        hidden: true
      },
      {
        path: "brand",
        name: "homeBrand",
        component: () => import("@/views/sms/brand/index"),
        meta: { title: "品牌推荐", icon: "product-brand", keepAlive: true }
      },
      {
        path: "new",
        name: "homeNew",
        component: () => import("@/views/sms/new/index"),
        meta: { title: "新品推荐", icon: "sms-new", keepAlive: true }
      },
      {
        path: "hot",
        name: "homeHot",
        component: () => import("@/views/sms/hot/index"),
        meta: { title: "人气推荐", icon: "sms-hot", keepAlive: true }
      },
      {
        path: "subject",
        name: "homeSubject",
        component: () => import("@/views/sms/subject/index"),
        meta: { title: "专题推荐", icon: "sms-subject", keepAlive: true }
      },
      {
        path: "bestseller",
        name: "bestseller",
        component: () => import("@/views/sms/bestseller/index"),
        meta: { title: "爆款推荐", icon: "sms-subject", keepAlive: true }
      },
      {
        path: "time",
        name: "time",
        component: () => import("@/views/sms/time/index"),
        meta: { title: "限时特惠", icon: "sms-subject", keepAlive: true }
      },
      {
        path: "advertise",
        name: "homeAdvertise",
        component: () => import("@/views/sms/advertise/index"),
        meta: { title: "广告列表", icon: "sms-ad", keepAlive: true }
      },
      {
        path: "addAdvertise",
        name: "addHomeAdvertise",
        component: () => import("@/views/sms/advertise/add"),
        meta: { title: "添加广告" },
        hidden: true
      },
      {
        path: "updateAdvertise",
        name: "updateHomeAdvertise",
        component: () => import("@/views/sms/advertise/update"),
        meta: { title: "编辑广告" },
        hidden: true
      }
    ]
  },
  {
    path: "/wechat",
    component: Layout,
    redirect: "/wechat/payment",
    name: "wechat",
    meta: { title: "商家账单", icon: "order" },
    children: [
      {
        path: "payment",
        name: "payment",
        component: () => import("@/views/wechat/payment"),
        meta: { title: "支付列表", icon: "order", keepAlive: true }
      },
      {
        path: "refund",
        name: "refund",
        component: () => import("@/views/wechat/refund"),
        meta: { title: "退款列表", icon: "order", keepAlive: true }
      },
      {
        path: "transfer",
        name: "transfer",
        component: () => import("@/views/wechat/transfer"),
        meta: { title: "转账列表", icon: "order", keepAlive: true }
      }
    ]
  },
  {
    path: "/ims",
    component: Layout,
    redirect: "/ims/integral",
    name: "ims",
    meta: { title: "积分", icon: "order" },
    children: [
      {
        path: "integral",
        name: "integral",
        component: () => import("@/views/ims/integral"),
        meta: { title: "积分兑换", icon: "product" }
      }
    ]
  },
  {
    path: "/ums",
    component: Layout,
    redirect: "/ums/admin",
    name: "ums",
    meta: { title: "权限", icon: "ums" },
    children: [
      {
        path: "admin",
        name: "admin",
        component: () => import("@/views/ums/admin/index"),
        meta: { title: "用户列表", icon: "ums-admin", keepAlive: true }
      },
      {
        path: "role",
        name: "role",
        component: () => import("@/views/ums/role/index"),
        meta: { title: "角色列表", icon: "ums-role", keepAlive: true }
      },
      {
        path: "allocMenu",
        name: "allocMenu",
        component: () => import("@/views/ums/role/allocMenu"),
        meta: { title: "分配菜单" },
        hidden: true
      },
      {
        path: "allocResource",
        name: "allocResource",
        component: () => import("@/views/ums/role/allocResource"),
        meta: { title: "分配资源" },
        hidden: true
      },
      {
        path: "menu",
        name: "menu",
        component: () => import("@/views/ums/menu/index"),
        meta: { title: "菜单列表", icon: "ums-menu", keepAlive: true }
      },
      {
        path: "addMenu",
        name: "addMenu",
        component: () => import("@/views/ums/menu/add"),
        meta: { title: "添加菜单" },
        hidden: true
      },
      {
        path: "updateMenu",
        name: "updateMenu",
        component: () => import("@/views/ums/menu/update"),
        meta: { title: "修改菜单" },
        hidden: true
      },
      {
        path: "resource",
        name: "resource",
        component: () => import("@/views/ums/resource/index"),
        meta: { title: "资源列表", icon: "ums-resource", keepAlive: true }
      },
      {
        path: "resourceCategory",
        name: "resourceCategory",
        component: () => import("@/views/ums/resource/categoryList"),
        meta: { title: "资源分类" },
        hidden: true
      }
    ]
  },
  { path: "*", redirect: "/404", hidden: true }
];

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
});



// WEBPACK FOOTER //
// ./src/router/index.js